/* eslint-disable */

require('daterangepicker');
const moment = require('moment');


let MainselectedTrip = 'roundTrip';
if (typeof calenderOpens === "undefined") {
	calenderOpens = "left";
}
//daysStep is the days step in Multi Destination between days


//for localcalender
moment.locale(localLang);

if (typeof selectedTrip !== "undefined") {
	MainselectedTrip = selectedTrip;
}
//to reset Select on Back
setTimeout(function () {
	$('.bookingForm select').each(function () {

		$(this).val(MainselectedTrip);
	})


}, 50)

const {
	keyframe
} = require('jquerykeyframes')
var validate = require("validate.js");
$.fn.selectpicker.Constructor.DEFAULTS.dropupAuto = false;
const destinationTemplate = require('../scripts/newDestination');
const destinationTemplateToOurSide = require('../scripts/newDestinationToOurSide')

var validate = require("validate.js");

let bookingForm = {
	airportsFrom: airportList,
	airportsTo: [],
	selectedDeparture: {},
	departureInstances: [],
	arrivalInstances: [],
	datesInstances: [],
	tripType: MainselectedTrip,
	isSingleDate: false,
	numberOfTrips: 1,
	trips: [],
	totalChairsAllowed: 9,
	lastTrip: moment().format('DD MMM YY'),
	lastTripDepart: moment().add(7, 'days').format('DD MMM YY'), //the return date after 7 days  (rounded Trip)
	// newTripadded: moment().add(1, 'days').format('DD MMM YY'),
	newTripadded: moment().format('DD MMM YY'), // the date We use to add new trip in the multiDestination Inputs
	newDate: moment().format('DD MMM YY'), //the date We use to loop in the multiDestination Inputs
	totalPassengers: 0,
	tMinDate: moment().format('DD MMM YY'),
	departureDate: () => {
		return moment().format('DD MMM YY')
	},
	arriveDate1: () => {
		return moment().format('DD MMM YY')
	},

	arriveDate: () => {
		return moment().add(7, 'days').format('DD MMM YY')
	},
	test: null
};


let bookMultiForm = {

	tripType: MainselectedTrip,
	isSingleDate: false,

};


function initNewTrip(index) {
	bookingForm.departureInstances.push({
		inst: initNewAirportsList(document.getElementById(`DepartureFrom-${index}`), bookingForm.airportsFrom)
	})
	bookingForm.arrivalInstances.push({
		inst: initNewAirportsList(document.getElementById(`DepartureTo-${index}`), bookingForm.airportsTo)
	})

	console.log('index', index);
	listenToDepartureChanges(document.getElementById(`DepartureFrom-${index}`), index)
	listenToDepartureToChanges(document.getElementById(`DepartureTo-${index}`), index)


};
//initNewTrip(bookingForm.departureInstances.length);
//check if charter Form or not for sendToOurSide forms (charterForm) /charter-form.html
var isCharterFlight = typeof charterFlight !== 'undefined' && charterFlight != 'false' && charterFlight != null && charterFlight != 'null' && charterFlight != "";
console.log('isCharterFlight', isCharterFlight)

if (isCharterFlight) {

	bookingForm.departureInstances.push({
		inst: (document.getElementById(`DepartureFrom-0`), bookingForm.airportsFrom)
	})
	bookingForm.arrivalInstances.push({
		inst: (document.getElementById(`DepartureTo-0`), bookingForm.airportsTo)
	})
} else {

	//initNewTrip(bookingForm.departureInstances.length);
	initNewTrip(bookingForm.departureInstances.length);

	//for time table form
	if (!$('#offersForm').length) {
		initNewTrip(10);
	}


}

function initNewAirportsList(el, list) {
	let awesomplete = new Awesomplete(el, {
		sort: function () {},
		maxItems: 10,
		maxItems: 100,
		list: list,
		minChars: 0,
		autoFirst: true,
		item: myItemFunc
	});


	$(el).on('focus', function () {
        // to scrolltop to the form
		$("html,body").animate({
			scrollTop: $(el).offset().top - $('.header').outerHeight() - 100
		}, 300)

		//not to show  awesomplete if doesn't select form destination first   
		if ((!$(this).parent().parent().parent().prev().find('.airportInput').hasClass('error')) && (!$(this).parent().parent().parent().prev().find('.airportInput').hasClass('invalid'))) {
			if (awesomplete.ul.childNodes.length === 0) {
				awesomplete.evaluate();
			} else if (awesomplete.ul.hasAttribute('hidden')) {
				awesomplete.open();

			} else {
				awesomplete.close();

			}

		}

	});
	return awesomplete;
};

//init
window.initSelectedDepartureInstancesAirportOnlIst = function (selectedIndex) {


	bookingForm.departureInstances[1].inst.open();
	bookingForm.departureInstances[1].inst.evaluate();
	bookingForm.departureInstances[1].inst.select(bookingForm.departureInstances[1].inst.ul.children[selectedIndex]);
	bookingForm.departureInstances[1].inst.close();
	bookingForm.arrivalInstances[1].inst.close();



}

window.initSelectedAirportOnlIst = function (selectedIndex) {
	console.log('ddd' ,bookingForm.arrivalInstances[1].inst,'selectedIndex',selectedIndex);
	bookingForm.arrivalInstances[1].inst.select(bookingForm.arrivalInstances[1].inst.ul.children[selectedIndex]);
	//bookingForm.arrivalInstances[1].inst.evaluate();

}
function listenToDepartureChanges(el, index) {

	$(el).on('awesomplete-selectcomplete', function (e, clickedIndex, isSelected, previousValue) {
		let selectedValue = e.target.value;
		bookingForm.selectedDeparture = bookingForm.airportsFrom.filter(res => {
			

			return selectedValue === res.value
		})


		if (typeof (bookingForm.arrivalInstances[index]) == "undefined") {
			index = 1;
			
		} 

		
		// for routeMap
		if ($(el).hasClass('routeMapInputSearch')) {
            $('.routeMapInputSearchTo').val('');
			window.initSelectedAirport(selectedValue);

			// close the arrivalInstances if opened
			bookingForm.arrivalInstances[1].inst.close();
			$('.routeMapInputSearch').blur();

			if(bookingForm.arrivalInstances[index].inst._list.length==1){
				//initSelectedAirportOnlIst(0);
			}
			if ($('#DepartureTo-0').length>0){
				$('#DepartureTo-0').val('');
			}
			if ($('#DepartureFrom-0').length>0){
				$('#DepartureFrom-0').val(selectedValue);
				$("#DepartureFrom-0").parent().parent().find('.floatingLabel').addClass('active');
			}
			//bookingForm.arrivalInstances[index].inst.select(bookingForm.arrivalInstances[index].inst.ul.children[1])

		}



		bookingForm.arrivalInstances[index].inst._list = bookingForm.selectedDeparture[0].destinations
		bookingForm.arrivalInstances[index].inst.evaluate()

		//bookingForm.departureInstances[1].inst.close();

	});
};



function listenToDepartureToChanges(el, index) {

	$(el).on('awesomplete-selectcomplete', function (e, clickedIndex, isSelected, previousValue) {
		let selectedValue = e.target.value;
		let selectedDesTo = [];

		if (typeof (bookingForm.arrivalInstances[index]) !== "undefined") {} else {
			index = 1;
		}
		selectedDesTo = bookingForm.arrivalInstances[index].inst._list.filter(res => {
			return selectedValue === res.value
		})
		// for routeMap
		if ($(el).hasClass('routeMapInputSearchTo')) {

			let selectedId=selectedDesTo[0].id;
		    const selectedIndex = bookingForm.arrivalInstances[index].inst._list.findIndex(x => x.id === selectedId)
		    window.clickMapMarker(selectedIndex);
			if ($('#DepartureTo-0').length>0){
				$('#DepartureTo-0').val(selectedValue);
				$("#DepartureTo-0").parent().parent().find('.floatingLabel').addClass('active');

			}
			

			
		}
		$(el).closest('form').addClass('closest');


	  // for  dependency 2022-12-19

		setTimeout(function () {

			if ((bookMultiForm.tripType === 'oneWay') || (bookMultiForm.tripType === 'roundTrip')) {
				selectNextElement('.bootstrap-select .dropdown-toggle');
			}




		}, 50)
	   // end for  dependency 2022-12-19



	});
};


function myItemFunc(text, input) {
	return Awesomplete.$.create("li", {
		innerHTML: createItem(text, input, this._list)
	});
}

function createItem(text, input, list) {
	const selectedObject = list.filter(res => {
		return text['value'] === res.value
	})
	return `
		<div class="row h-100">
			<div class="col-12 d-flex justify-content-between font-weight-bold text-capitalize">
				<span>${selectedObject[0].city}</span>
				<span>${selectedObject[0].country}</span>
			</div>
			<div class="col-12">
				<span class="font-weight-light">${selectedObject[0].airport} - ${selectedObject[0].city} ${selectedObject[0].country}</span>
			</div>
		</div>
	`;
}
//start hotelInputSearch
if ($('.hotelInputSearch').length > 0) {
	initAutocompleteList(document.getElementById('hotelInputSearch'), hotelsList)
}

function initAutocompleteList(el, list) {

	let hotelsawsomecomplete = new Awesomplete(el, {
		sort: function () {},
		maxItems: 50,
		maxItems: 100,
		list: list,
		minChars: 0,
		autoFirst: true,
		item: myHotelItemFunc,

	});


	$(el).on('focus', function () {
		//not to show  awesomplete if doesn't select form destination first   
		if (hotelsawsomecomplete.ul.childNodes.length === 0) {
			hotelsawsomecomplete.evaluate();
		} else if (hotelsawsomecomplete.ul.hasAttribute('hidden')) {
			hotelsawsomecomplete.open();

		} else {
			hotelsawsomecomplete.close();

		}


	});
	return hotelsawsomecomplete;


};

function myHotelItemFunc(text, input) {

	return Awesomplete.$.create("li", {
		innerHTML: createHotelItem(text, input, this._list)
	});
}

function createHotelItem(text, input, list) {
	const selectedObject = list.filter(res => {
		return text['value'] === res.value
	})
	return `
			<div class="row h-100">
				<div class="col-12 d-flex justify-content-between font-weight-bold text-capitalize">
					<span>${selectedObject[0].city}</span>
					<span>${selectedObject[0].country}</span>
				</div>
				<div class="col-12">
					<span class="font-weight-light">${selectedObject[0].hotel} 
				</div>
			</div>
		`;

}
//end hotelInputSearch






// get the activeBookingForm to use in dependency 2022-12-19
let activeBookingForm = $('.bookingForm .formRow');

(function injectSomeDefaults() {
	$(`.departDateValue-0`).html(bookingForm.departureDate);
	$(`.arriveDateValue-0`).html(bookingForm.arriveDate);

	if ($('#bookingTabs').length > 0) {
		$('#bookingTabs a:first').tab('show');
		$('.bookingForms .tab-pane:first').find('.formRow').addClass('selectdWrappTrip');

	} else {
		$('.formRow').addClass('selectdWrappTrip');

	}

	// get the activeBookingForm to use in dependency 2022-12-19
	if ($('.bookingForm .formRow').length > 1) {
		activeBookingForm = $('.bookingForm .tab-pane.active .formRow');
	}
	$('.bookingForm  .nav-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		activeBookingForm = $('.bookingForm .tab-pane.active .formRow');
		console.log('activeBookingForm change', activeBookingForm);

	});

})();
//initDatePickerMulti
function initDatePickerMulti(el) {
	let autoClose = bookingForm.isSingleDate; //auto clse calender (show apply btn)

	el.daterangepicker({
		'opens': calenderOpens,
		drops: 'down',

		autoApply: false,
		autoUpdateInput: true,

		startDate: bookingForm.lastTrip,
		endDate: bookingForm.lastTripDepart,
		minDate: moment().format('DD MMM YY'),

		locale: calenderLocal,
	}, function (start, end, label) {


		$(el).siblings('.customDatePicker').find('.departDateValue').addClass('sss').html(start.format('DD MMM YY'))
		$(el).siblings('.customDatePicker').find('.arriveDateValue').addClass('sss').html(end.format('DD MMM YY'))


	});

	// bookingForm.datesInstances.push(el);

	// debugger
}

//end initDatePickerMulti
function initDatePicker(el) {
	let theactiveisSingleDate = bookingForm.isSingleDate;
	//bookMultiForm.tripType
	if ($(el).hasClass('datePicker-0')) {
		theactiveisSingleDate = bookMultiForm.isSingleDate;
	} else {
		theactiveisSingleDate = bookingForm.isSingleDate;
	}
	let autoClose = theactiveisSingleDate; //auto clse calender (show apply btn)

	//remove this ine for localcalender
	//bookingForm.lastTripDepart = moment(bookingForm.lastTrip).add(7, 'days').format('DD MMM YY');
	bookingForm.lastTripDepart = moment(bookingForm.lastTrip, "DD MMM YY").add(7, 'days').format('DD MMM YY');

	//for the offers-details-form with autodate selected
	if (typeof selectedDepartTrip !== "undefined") {
		bookingForm.lastTrip = selectedDepartTrip;
		////change  this line for localcalender
		//bookingForm.tMinDate = moment(bookingForm.lastTrip).format('DD MMM YY');
		bookingForm.tMinDate = bookingForm.lastTrip;
	}
	if (typeof selectedReturnTrip !== "undefined") {
		bookingForm.lastTripDepart = selectedReturnTrip;
	}


	//end for the offers-details-form with autodate selected
	////change  this line for localcalender
	//$(el).siblings('.customDatePicker').find('.departDateValue').html(moment(bookingForm.lastTrip).format('DD MMM YY'));

	$(el).siblings('.customDatePicker').find('.departDateValue').html(bookingForm.lastTrip);
	$(el).siblings('.customDatePicker').find('.arriveDateValue').html(bookingForm.lastTripDepart);


	el.daterangepicker({
		singleDatePicker: theactiveisSingleDate,
		'opens': calenderOpens,
		drops: 'down',
		// parentEl: `.customDatePicker`,
		// autoApply: true,
		autoApply: autoClose,
		autoUpdateInput: true,

		startDate: bookingForm.lastTrip,
		endDate: bookingForm.lastTripDepart,
		minDate: bookingForm.tMinDate,




		locale: calenderLocal,

	}, function (start, end, label) {
		bookingForm.lastTrip = start.format('DD MMM YY');
		if ($(el).hasClass('datePicker-0')) {
			bookingForm.newTripadded = start;
			let datesInputs = document.querySelectorAll('#moreDestinations .datePicker');
			// bookingForm.newDate = start.format('DD MMM YY');
			bookingForm.newDate = moment(start, "DD MMM YY");



			// for sendToOurSide forms (charterForm) from and to dates in the same day

			if ($('.sendToOurSide').length > 0) {
				if ($(el).hasClass('datePicker-start')) {

					let newDateToInit = moment(bookingForm.newDate, "DD MMM YY");
					$('.datePicker-end').data('daterangepicker').minDate = moment(newDateToInit, "DD MMM YY");
					$('.datePicker-end').data('daterangepicker').startDate = moment(newDateToInit, "DD MMM YY");
					$('.datePicker-end').val(bookingForm.lastTrip);
				}
			}






			updateMultiDstination();

		}
		if (bookMultiForm.isSingleDate) {






			$(el).siblings('.customDatePicker').find('.departDateValue').html(start.format('DD MMM YY'))
		} else {

			$(el).siblings('.customDatePicker').find('.departDateValue').html(start.format('DD MMM YY'))
			$(el).siblings('.customDatePicker').find('.arriveDateValue').html(end.format('DD MMM YY'))
		}

		if (bookingForm.isSingleDate) {



			$(el).siblings('.customDatePicker').find('.departDateValue').html(start.format('DD MMM YY'))
		} else {

			$(el).siblings('.customDatePicker').find('.departDateValue').html(start.format('DD MMM YY'))
			$(el).siblings('.customDatePicker').find('.arriveDateValue').html(end.format('DD MMM YY'))
		}


	});


		// for  dependency 2022-12-19
		el.on('apply.daterangepicker', function (ev, picker) {
			setTimeout(function () {
	
	
	
				// for  dependency 2022-12-19
				if ((bookMultiForm.tripType === 'oneWay') || (bookMultiForm.tripType === 'roundTrip')) {
	
					selectNextElement('.positionTrigger');
				}
	
			}, 100)
		});
		// end for  dependency 2022-12-19

	// bookingForm.datesInstances.push(el);

	// debugger
}



function initDatePicker2(el) {
	el.daterangepicker({
		singleDatePicker: bookMultiForm.isSingleDate,
		'opens': calenderOpens,
		drops: 'down',
		// parentEl: `.customDatePicker`,
		autoApply: true,
		autoUpdateInput: true,
		minDate: bookingForm.newTripadded,
		startDate: bookingForm.newTripadded,

		locale: calenderLocal,

	}, function (start, end, label) {

		// if (bookingForm.isSingleDate) {
		if (true) {
			bookingForm.newTripadded = start;
			let datesInputs = document.querySelectorAll('#moreDestinations .datePicker');

			let currentValue = $('input.datePicker-0').val();
			$(el).siblings('.customDatePicker').find('.departDateValue').html(start.format('DD MMM YY'));

			bookingForm.newDate = start;



			let index = $(el).closest('.new-destination-row').index();
			let kk = 0;

			// // for sendToOurSide forms (charterForm) from and to dates in the same day

			// if ($('.sendToOurSide').length > 0) {
			// 	kk = -1
			// }

			for (let i = index; i < datesInputs.length; i++) {
				kk=kk+daysStep;
				if (i > -1) {
					let newDate2;
					// for sendToOurSide forms (charterForm) from and to dates in the same day
					
					if ($(el).closest('.new-destination-row').next().length > 0) {


						newDate2 = moment(bookingForm.newDate).add(kk - 0, 'days').format('DD MMM YY');


						if ($(datesInputs[i + 1]).length > 0) {
							$(datesInputs[i + 1]).data('daterangepicker').minDate = moment(newDate2, "DD MMM YY");
							$(datesInputs[i + 1]).data('daterangepicker').startDate = moment(newDate2, "DD MMM YY");


							// for sendToOurSide forms (charterForm)
							$(datesInputs[i + 1]).val(newDate2);
							//end for  sendToOurSide forms (charterForm)


							$(datesInputs[i + 1]).closest('.new-destination-row').find('.departDateValue').html(newDate2);
							bookingForm.newTripadded = newDate2;
						}
					}
				}



			}

			bookingForm.lastTrip = start.format('DD MMM YY')


		} else {

			$(el).siblings('.customDatePicker').find('.departDateValue').html(start.format('DD MMM YY'))
			$(el).siblings('.customDatePicker').find('.arriveDateValue').html(end.format('DD MMM YY'))
		}

	});

	// bookingForm.datesInstances.push(el);

	// debugger
}

function updateMultiDstination() {

	if ($('#moreDestinations .datePicker').length > 0) {
		let datesInputs = document.querySelectorAll('#moreDestinations .datePicker');
		let currentValue = $('input.datePicker-0').val();
		let kk = 0;


		for (let i = 0; i < datesInputs.length; i++) {
			kk=kk+daysStep;
			if (i > -1) {
				let newDate2;
				// for sendToOurSide forms (charterForm) from and to dates in the same day
		


				if ($(datesInputs[i]).length > 0) {

					newDate2 = moment(bookingForm.newDate).add(kk - 0, 'days').format('DD MMM YY');
					$(datesInputs[i]).data('daterangepicker').minDate = moment(newDate2, "DD MMM YY");
					$(datesInputs[i]).data('daterangepicker').startDate = moment(newDate2, "DD MMM YY");
					$(datesInputs[i]).closest('.new-destination-row').find('.departDateValue').addClass('lolo').html(newDate2);
					// for sendToOurSide forms (charterForm)
					$(datesInputs[i]).val(newDate2);
					//end for sendToOurSide forms (charterForm)

					bookingForm.newTripadded = newDate2;


				}
			}




		}

	}
}





function functionCheckFormType() {

	let aDatepicker = $('.formRow.selectdWrappTrip');
	//check if form has multidestination or no // for timetable Tab
	if (aDatepicker.find('.datePicker-a').length > 0) {
		if (bookingForm.tripType === 'oneWay') {
			bookingForm.isSingleDate = true;
			$(aDatepicker).find('.returnJunk').addClass('d-none');

			initDatePicker($('.formRow.selectdWrappTrip').find('input.datePicker-a'));

		} else if (bookingForm.tripType === 'roundTrip') {
			bookingForm.isSingleDate = false;

			$(aDatepicker).find('.returnJunk').removeClass('d-none');

			initDatePicker($('.formRow.selectdWrappTrip').find('input.datePicker-a'));

		}
		if (bookingForm.tripType === 'multiDestination') {
			bookingForm.isSingleDate = true
			$(aDatepicker).find('.returnJunk').addClass('d-none');

			initDatePicker($('.formRow.selectdWrappTrip').find('input.datePicker-a'));


		} else {

		}

	}

	// for not timetable Tabs
	else {
		if (bookMultiForm.tripType === 'oneWay') {
			bookMultiForm.isSingleDate = true;
			$(aDatepicker).find('.returnJunk').addClass('d-none');
			$('#moreDestinations').addClass('d-none')

			initDatePicker($('.formRow.selectdWrappTrip').find('input.datePicker-0'));

		} else if (bookMultiForm.tripType === 'roundTrip') {
			bookMultiForm.isSingleDate = false;
			$('#moreDestinations').addClass('d-none')

			$(aDatepicker).find('.returnJunk').removeClass('d-none');

			initDatePicker($('.formRow.selectdWrappTrip').find('input.datePicker-0'));

		}
		if (bookMultiForm.tripType === 'multiDestination') {
			bookMultiForm.isSingleDate = true
			$(aDatepicker).find('.returnJunk').addClass('d-none');

			initDatePicker($('.formRow.selectdWrappTrip').find('input.datePicker-0'));

			isMultiple(true);
		} else {
			isMultiple(false)
		} //end

	}






}
functionCheckFormType();


// for sendToOurSide forms (charterForm) defalut date is single as design two fields
if ($('.sendToOurSide').length > 0) {
	bookingForm.isSingleDate = true;
	bookMultiForm.isSingleDate = true;


}



//https://www.daterangepicker.com/#options
initDatePicker($('input.datePicker-0')); //has multie destination
initDatePicker($('input.datePicker-a'));
initDatePickerMulti($('input.datePicker-multi'));



(function initBootstrapSelect() {
	$(`.selectpickerCustom`).selectpicker();
	$(`.selectpickerCustom`).val(bookingForm.tripType)
})();

function isMultiple(param) {
	// $('#DepartureFrom-0').focus()

	if ($('#bookingForm .formRow.selectdWrappTrip').find('input.datePicker-0').length > 0) {
		if (param) {
			$('#bookingForm .formRow.selectdWrappTrip').addClass('multiple')
			$('.formRow.selectdWrappTrip #moreDestinations').removeClass('d-none')
			$('.formRow.selectdWrappTrip .addMore').removeClass('d-none')
		} else {
			$('#bookingForm .formRow.selectdWrappTrip').removeClass('multiple')
			$('.formRow.selectdWrappTrip #moreDestinations').addClass('d-none')
			$('.formRow.selectdWrappTrip .addMore').addClass('d-none')
		}
	}


}


// for  dependency 2022-12-19
function selectNextElement(nextElement) {
	let n = activeBookingForm.find(nextElement);
	n.click();


}
//end for  dependency 2022-12-19


(function bootstrapTriggers(el = $('.selectpickerCustom')) {
	el.on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		// for sendToOurSide forms (charterForm)
		if ($(e.target).parent().parent().closest('.formRow').hasClass('sendToOurSide')) {
			bookingForm.tripType = e.target.value;
			bookingForm.isSingleDate = true;

			$(e.target).closest('formRow').addClass('selectdWrappTrip');
			if ((bookingForm.tripType === 'oneWay') || (bookingForm.tripType === 'multiDestination')) {
				$('.endDate').addClass('disabled pointer-none d-none');
				if (bookingForm.tripType === 'oneWay') {
					$('.tripInfo').addClass('oneWay').removeClass('multiDes');

				} else {
					$('.tripInfo').addClass('multiDes').removeClass('oneWay');

				}

			} else {
				$('.endDate').removeClass('disabled pointer-none d-none');
				$('.tripInfo').removeClass('oneWay multiDes');

			}
			if (bookingForm.tripType === 'multiDestination') {

				$('.formRow.selectdWrappTrip #moreDestinations').removeClass('d-none')
				$('.formRow.selectdWrappTrip .addNMore').removeClass('d-none')
			} else {
				$('#bookingForm .formRow.selectdWrappTrip').removeClass('multiple')
				$('.formRow.selectdWrappTrip #moreDestinations').addClass('d-none')
				$('.formRow.selectdWrappTrip .addNMore').addClass('d-none')
			}

			// end for sendToOurSide forms (charterForm)

		} else {


			$('.formRow.selectdWrappTrip').removeClass('selectdWrappTrip');
			let selectedLabel = $($(e.target).children()[clickedIndex]).attr('label');
			$(e.target).closest('.formRow').addClass('selectdWrappTrip');

			$(e.target).val(e.target.value)
			$('input.datePicker-0').val('')
			//bookingForm.lastTrip = moment().format('DD MMM YY');
			$(e.target).parent().parent().find('.selectedValue.FormType').addClass('ddddd').html(selectedLabel)
			if ($(e.target).parent().parent().closest('.formRow').find('input.datePicker-0').length > 0) {
				bookMultiForm.tripType = e.target.value;
			} else {
				bookingForm.tripType = e.target.value;
			}
			functionCheckFormType();
			$(e.target).closest('formRow').addClass('selectdWrappTrip');

		}
	});
	// for  dependency 2022-12-19

	$(".bootstrap-select").delegate(".dropdown-menu li", "click", function (e) {
		// for  dependency 2022-12-19
		console.log('bookMultiForm.tripType', bookMultiForm.tripType)
		setTimeout(function () {
			if ((bookMultiForm.tripType === 'oneWay') || (bookMultiForm.tripType === 'roundTrip')) {

				selectNextElement('.customDatePicker');
			}


		}, 100)

	})
	// end 	for  dependency 2022-12-19

	el.on('show.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		$(this).parent().parent().find('.arrow').addClass('active');
	});

	el.on('hide.bs.select', function (e, clickedIndex, isSelected, previousValue) {
		$(this).parent().parent().find('.arrow').removeClass('active');
	});
})();


function UpdatePassengers() {
	bookingForm.totalPassengers = 0;
	for (const number of $(`.numberControl`)) {
		bookingForm.totalPassengers = bookingForm.totalPassengers + parseInt($(number).val());
	}
	$(`.positionTrigger .selectedValue`).html(bookingForm.totalPassengers)
};
UpdatePassengers();

(function passengersControl() {
	$('.minus').click(function (e) {
		e.preventDefault();
		let currentVal = $(this).siblings('input').val();
		if ($(this).hasClass('adult')) {
			if (currentVal > 1) {
				$(this).siblings().removeClass('disabled')
				$(this).siblings('input').val(parseInt(currentVal, 10) - 1)
				if ((parseInt(currentVal, 10) - 1) == 1) {
					$(this).addClass('disabled')
				}
				if ($('.infantControl').val() > currentVal - 1) {
					$('.infantControl').val(currentVal - 1)
					//
				}
			} else {
				$(this).addClass('disabled')
			}
		} else {
			if (currentVal > 0) {
				$(this).siblings().removeClass('disabled')
				$(this).siblings('input').val(parseInt(currentVal, 10) - 1)
				if ((parseInt(currentVal, 10) - 1) == 0) {
					$(this).addClass('disabled')
				}
			} else {
				$(this).addClass('disabled')
			}
		}
		UpdatePassengers()
	});
	$('.adds').click(function (e) {
		e.preventDefault();
		let currentChairs = parseInt($(`.adultControl`).val()) + parseInt($(`.childrenControl`).val());
		let currentVal = $(this).siblings('input').val();
		if ($(this).hasClass('infant')) {
			if ($(`.adultControl`).val() > currentVal) {
				if (currentVal < 20) {
					$(this).siblings().removeClass('disabled')
					$(this).siblings('input').val(parseInt(currentVal, 10) + 1)
					if ((parseInt(currentVal, 10) + 1) == $(`.adultControl`).val()) {
						$(this).addClass('disabled')
					}
				} else {
					$(this).addClass('disabled')
				}
			}
		} else {
			if (currentVal < 9 && currentChairs < 9) {
				$(this).siblings().removeClass('disabled')
				$(this).siblings('input').val(parseInt(currentVal, 10) + 1)
				if ((parseInt(currentVal, 10) + 1) == 20) {
					$(this).addClass('disabled')
				}
				if ($(this).hasClass('adult')) {
					$(`.infantControl`).siblings('.adds').removeClass('disabled');
				}
			} else {
				$(this).addClass('disabled')
			}
		}
		UpdatePassengers()
	});
})();


function fakeTriggers() {
	$('.customDatePicker').click(function () {
		$(this).parent().find('input.datePicker').click()
	});

	$(`.airportInput`).on('awesomplete-close', function (reason) {
		if (reason.originalEvent.reason === "nomatches") {
			$(this).addClass('invalid').removeClass('valid');

		} else {
			$(this).removeClass('invalid airportInputFocusCheck');
			if ($(this).parent().parent().parent().next().find('.airportInput').length > 0) {
				$(this).parent().parent().parent().next().find('.airportInput').addClass('addcheckfocus1').focus();
			} else {

			}

		}
		if (reason.originalEvent.reason != "blur") {
			if (reason.originalEvent.reason != "nomatches") {

				$(this).parent().parent().parent().next().find('.airportInput').focus().val('');
			}
		}

		// $($(this).parent().parent().parent().siblings()[0]).children('airportInput').focus();

	});
	$('.form-control.outline').focus(function (e) {
		$(this).parent().siblings('.floatingLabel').addClass('active');
		if ($(this).hasClass('depart-auto')) {
			$(this).addClass('airportInputFocusCheck');
		}
	});

	$('.form-control.outline').blur(function () {
		if (!$(this).val()) $(this).parent().siblings('.floatingLabel').removeClass('active');
		if ($(this).hasClass('depart-auto')) {
			//	$(this).removeClass('airportInputFocus');

			if ($(this).hasClass('invalid') || $(this).hasClass('airportInputFocusCheck')) {
				$(this).val('');

			}

		}
	});
}
fakeTriggers();


(function initpassengerSelect() {
	$(`.positionTrigger`).click(function (e) {
		e.preventDefault();
		// $(`.selectpickerCustom`).hide();
		$('.passengerSelect').toggleClass('show')
	});
	$(document).click(function () {
		$(".passengerSelect").removeClass('show');
	});
	$(".passengerSelect").click(function (event) {
		event.stopPropagation();
	});
	$(".positionTrigger").click(function (event) {
		event.stopPropagation();
		// $(`.selectpickerCustom`).hide();
	});
})();

$('.addMore').click(function (e) {
	e.preventDefault();
	if ($('#moreDestinations').children().length < 5) {
		let index = bookingForm.departureInstances.length
		$('#moreDestinations').append(destinationTemplate.appendDestinationTemplate(index));
		initNewTrip(index);
		index = index - 1;
		let newTripDate = bookingForm.newTripadded;
		bookingForm.newTripadded = moment(newTripDate, "DD MMM YY").add(daysStep, 'days').format('DD MMM YY');

		//   = moment(bookingForm.newTripadded).add(1, 'days').format('DD MMM YY');
		initDatePicker2($(`input.datePicker-${bookingForm.departureInstances.length - 1}`));

		$(`.departDateValue-${bookingForm.departureInstances.length - 1}`).html(bookingForm.newTripadded);
		initListeners()

		if ($('#moreDestinations').children().length === 5) $('.addMore').addClass('d-none')
	} else {
		$('.addMore').addClass('d-none')
	}
})


$('.addNMore').click(function (e) {
	e.preventDefault();
	if ($('#moreDestinations').children().length < 4) {
		let index = bookingForm.departureInstances.length
		$('#moreDestinations').append(destinationTemplateToOurSide.appendDestinationTemplateToOurSide(index));
		//check if charter Form or not for sendToOurSide forms (charterForm) /charter-form.html
		if (isCharterFlight) {

			bookingForm.departureInstances.push({
				inst: (document.getElementById(`DepartureFrom-${index}`), bookingForm.airportsFrom)
			})
			bookingForm.arrivalInstances.push({
				inst: (document.getElementById(`DepartureTo-${index}`), bookingForm.airportsTo)
			})
		} else {
			initNewTrip(index);
		}
		index = index - 1;
		let newTripDate = bookingForm.newTripadded;
		bookingForm.newTripadded = moment(newTripDate, "DD MMM YY").add(daysStep, 'days').format('DD MMM YY');
		initDatePicker2($(`input.datePicker-${bookingForm.departureInstances.length - 1}`));
		$(`.departDateValue-${bookingForm.departureInstances.length - 1}`).html(bookingForm.newTripadded);
		$(`input.datePicker-${bookingForm.departureInstances.length - 1}`).val(bookingForm.newTripadded);

		initListeners()
		//n updateMultiDstination();
		if ($('#moreDestinations').children().length === 3) $('.addNMore').addClass('d-none')
	} else {
		$('.addNMore').addClass('d-none')
	}
})



$(".bookingForms").delegate(".switchDestinations", "click", function (e) {

	e.preventDefault();
	let inputs = $(this).parent().parent().find('input');
	if ($(this).closest('.new-destination-row').length > 0) {
		inputs = $(this).closest('.new-destination-row').find('input');
	}

	const from = $(inputs[0]).val();
	const to = $(inputs[1]).val();


	$(inputs[0]).addClass('tooo').val(to);
	$(inputs[1]).addClass('from').val(from);
	// $(inputs[0]).val() ? $(inputs[0]).addClass('addcheckfocus00') : $(inputs[0]).blur().addClass('addcheckfocusa00')
	// $(inputs[1]).val() ? $(inputs[1]).addClass('addcheckfocusaa') : $(inputs[1]).blur().addClass('addcheckfocusaabb')
	$(inputs[0]).val() ? $(inputs[0]).addClass('addcheckfocus00') : $(inputs[0]).addClass('addcheckfocusa00');
	$(inputs[1]).val() ? $(inputs[1]).addClass('addcheckfocusaa') : $(inputs[1]).addClass('addcheckfocusaabb');
	$(this).playKeyframe('spin 200ms ease-in-out 0s 1 normal forwards');
	$(this).toggleClass('active')
});

function initListeners() {

	fakeTriggers()

	$('#bookingForm').submit(function (e) {
		// e.preventDefault()
		// get all the inputs into an array.
		var $inputs = $('#bookingForm :input');

		// not sure if you wanted this, but I thought I'd add it.
		// get an associative array of just the values.
		var values = {};
		$inputs.each(function () {
			values[this.name] = $(this).val();
		});

	});
	$('.bookingForm form').submit(function (e) {
		// e.preventDefault()
		// get all the inputs into an array.
		var $inputs = $(this).find('input');

		// not sure if you wanted this, but I thought I'd add it.
		// get an associative array of just the values.
		var values = {};
		$inputs.each(function () {
			values[this.name] = $(this).val();
		});

	});
	$('#moreDestinations').on('click', '.deleteRow', function () {

		$(this).parent().remove();
		if ($(this).hasClass('deleteNRow')) {
			if ($('#moreDestinations').children().length < 3) {
				$('.addNMore').removeClass('d-none')
			}
		}
		if ($('#moreDestinations').children().length < 5) {
			$('.addMore').removeClass('d-none')
		}



		if ($('#moreDestinations .new-destination-row').last().length > 0) {
			let lastdate = $('#moreDestinations .new-destination-row').last().find('.datePicker');

			bookingForm.newTripadded = moment(lastdate.val(), "DD MMM YY");
		} else {
			bookingForm.newTripadded = moment($('input.datePicker-0').val(), "DD MMM YY");
			// moment($('input.datePicker-0').val()).add(0, 'days').format('DD MMM YY');

		}

		//updateDateRangesValidation();
	});
}
initListeners()









//start routeMapInputSearch
if ($('.routeMapInputSearch').length > 0) {
	initNewTrip(10);
}







//end routeMapInputSearch